<template>
  <div class="popup">
    <Loader v-if="loading" />
    <h4 class="popup__title">{{ isEdit ? 'Редактирование менеджера' : 'Создание менеджера' }}</h4>

    <div class="form">
      <div class="form__item">
        <div class="label">Имя *</div>
        <div class="input">
          <input type="text" v-model="form.name" />
        </div>
      </div>
      <div class="form__item">
        <div class="label">Email *</div>
        <div class="input">
          <input
            :class="{ invalid: !emailValid }"
            type="email"
            v-model="form.email"
            @focus="emailValid = true"
            @blur="validateEmail(form.email)"
          />
        </div>
      </div>
      <div class="form__item">
        <div class="label">Статус</div>
        <div class="input">
          <v-select
            :class="{ green: form.status === 1, red: form.status === 2 }"
            :options="user_statuses"
            label="name"
            :reduce="(option) => option.id"
            v-model="form.status"
            :clearable="false"
            :searchable="false"
          />
        </div>
      </div>
      <div class="form__item cards-block">
        <div class="label">Номер карты</div>
        <div class="scroll-block">
          <div v-for="(card, index) of form.cards_ids" :key="index" class="card-input">
            <v-select
              :options="cardsSelect"
              label="number"
              v-model="form.cards_ids[index]"
              :reduce="(option) => option.id"
              :clearable="false"
              :searchable="true"
              @search="fetchOptions"
              :appendToBody="true"
            >
              <template #no-options>Введите номер</template>
            </v-select>
            <button
              @click="removeCard(index)"
              :disabled="form.cards_ids.length === 1"
              :style="{ opacity: form.cards_ids.length === 1 ? '.5' : '1' }"
            >
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6.42857 5.25V3.6C6.42857 3.24196 6.56403 2.89858 6.80515 2.64541C7.04627 2.39223 7.37329 2.25 7.71429 2.25H10.2857C10.6267 2.25 10.9537 2.39223 11.1949 2.64541C11.436 2.89858 11.5714 3.24196 11.5714 3.6V5.25M14.25 5.25L13.5 14.4C13.5 14.758 13.3645 15.1014 13.1234 15.3546C12.8823 15.6078 12.5553 15.75 12.2143 15.75H5.78571C5.44472 15.75 5.1177 15.6078 4.87658 15.3546C4.63546 15.1014 4.5 14.758 4.5 14.4L3.75 5.25H14.25Z"
                  stroke="#6DB534"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path d="M3 5.25H4.33333H15" stroke="#6DB534" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
          </div>
        </div>
        <button class="add-card-btn" @click="addNewCard()">
          <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.25 9H2.75" stroke="#6DB534" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9.5 2.25V15.7501" stroke="#6DB534" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          Добавить карту
        </button>
      </div>
    </div>

    <div class="actions">
      <button class="button btn-primary" @click="closeAll()">Отмена</button>
      <button class="button btn-primary" :disabled="disabledSubmitButton" @click="save()">Сохранить</button>
    </div>
  </div>
</template>

<script>
import { popups } from '@/mixins/popups'
import { validation } from '@/mixins/validation'
import { mapActions, mapMutations, mapState } from 'vuex'
import vSelect from 'vue-select'
import Loader from '@/components/common/Loader.vue'

import 'vue-select/dist/vue-select.css'

export default {
  name: 'clientManagerPopup',
  components: {
    vSelect,
    Loader
  },
  mixins: [popups, validation],
  data: () => ({
    loading: false,
    emailValid: true,
    form: {
      name: '',
      email: '',
      status: 1,
      cards_ids: [null]
    }
  }),
  computed: {
    ...mapState({
      cardsSelect: (state) => state.admin.cardsSelect,
      clientManager: (state) => state.popups.clientManager,
      user_statuses: (state) => state.user.user_statuses,
      myUser: (state) => state.user.myUser
    }),
    isEdit() {
      return this.clientManager != null
    },
    disabledSubmitButton() {
      return !this.form.name?.trim() || !this.form.email?.trim() || !this.emailValid
    }
  },
  methods: {
    ...mapActions({
      getCardsSelect: 'getCardsSelect',
      createClientManager: 'createClientManager',
      editClientManager: 'editClientManager'
    }),
    ...mapMutations({
      setClientManager: 'SET_CLIENT_MANAGER'
    }),
    addNewCard() {
      this.form.cards_ids.push(null)
    },
    removeCard(index) {
      this.form.cards_ids.splice(index, 1)
    },
    getCardsSelectParams() {
      const customerId = this.myUser?.customer_id ?? this.myUser?.customer?.id
      return customerId ? { customer_id: customerId } : {}
    },
    async loadCardsSelect() {
      await this.getCardsSelect(this.getCardsSelectParams())
    },
    async fetchOptions(search, loading) {
      if (search.length >= 3) {
        loading(true)
        await this.loadCardsSelect()
        loading(false)
      }
    },
    initForm() {
      if (this.isEdit) {
        const manager = this.clientManager
        const cardIds = Array.isArray(manager.card_ids) && manager.card_ids.length
          ? [...manager.card_ids]
          : Array.isArray(manager.cards_ids) && manager.cards_ids.length
            ? [...manager.cards_ids]
            : [null]
        this.form = {
          name: manager.name || '',
          email: manager.email || '',
          status: manager.status_id ?? 1,
          cards_ids: cardIds
        }
      } else {
        this.form = {
          name: '',
          email: '',
          status: 1,
          cards_ids: [null]
        }
      }
      this.emailValid = true
    },
    async save() {
      this.validateEmail(this.form.email)
      if (!this.emailValid) {
        return
      }

      this.loading = true
      const payload = {
        name: this.form.name.trim(),
        email: this.form.email.trim(),
        status: this.form.status,
        cards_ids: this.form.cards_ids.filter((id) => id != null)
      }

      try {
        if (this.isEdit) {
          await this.editClientManager({
            id: this.clientManager.id,
            data: payload
          })
        } else {
          await this.createClientManager(payload)
        }
      } finally {
        this.loading = false
      }
    }
  },
  async mounted() {
    this.initForm()
    await this.loadCardsSelect()
  }
}
</script>

<style scoped lang="scss">
@import '../../styles/variables';

.popup {
  width: 100%;
  max-width: 350px;

  :deep(.loader) {
    height: 200%;
    width: 200%;
    left: -50%;
    top: -50%;
    border-radius: 25px;
    transform: scale(0.5);
    svg {
      position: unset;
    }
  }

  .form {
    width: 100%;
    align-self: stretch;
    max-width: 100%;
  }

  .form__item {
    flex-direction: column;
    width: 100%;
  }

  .form__item .label {
    width: 100%;
    margin: 0 0 5px;
  }

  .input {
    width: 100%;
  }

  input {
    width: 100%;
  }

  :deep(.v-select) {
    width: 100%;
  }

  .cards-block {
    margin-top: 10px;
    width: 100%;
  }

  .scroll-block {
    width: 100%;
    max-height: 60vh;
    overflow: auto;
  }

  .card-input {
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 5px;

    :deep(.v-select) {
      flex: 1;
      width: 100%;
    }

    & > button {
      flex-shrink: 0;
      margin-left: 10px;
      border: none;
      background: none;
    }
  }
}

.add-card-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0;
  padding: 10px;
  color: #6db534;
  font-size: 12px;
  border: 1px solid #6db534;
  border-radius: 4px;
  background: none;
  transition: all ease 0.3s;

  svg {
    margin-right: 10px;

    path {
      transition: all ease 0.3s;
    }
  }

  &:hover {
    background: $green;
    color: #ffffff;

    svg path {
      stroke: #ffffff;
    }
  }
}

</style>
